import React from 'react';
import styled from 'styled-components';

const MainContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    position: relative;
    justify-content: center;
    top: 110px;
`;

export const Main = ({ children }) => {
    return (
        <MainContainer>
            {children}
        </MainContainer>
    );
};

export default Main;
